function normalize(path) {
  const p = path.replace(/^#/, "").trim();
  const withSlash = p.startsWith("/") ? p : `/${p}`;
  return withSlash.length > 1 ? withSlash.replace(/\/+$/, "") : "/";
}
function fromLocation() {
  try {
    return normalize(window.location.hash);
  } catch {
    return "/";
  }
}
export const router = $state({ path: fromLocation() });
export function segments(path = router.path) {
  return path.split("/").filter(Boolean);
}
export function seg(index, path = router.path) {
  return segments(path)[index] ?? null;
}
export function navigate(path, opts = {}) {
  const next = normalize(path);
  router.path = next;
  try {
    if (window.location.hash === `#${next}`) return;
    const url = `${window.location.pathname}${window.location.search}#${next}`;
    if (opts.replace) window.history.replaceState(null, "", url);
    else window.history.pushState(null, "", url);
  } catch {
  }
}
let attached = false;
export function initRouter() {
  router.path = fromLocation();
  if (attached) return;
  attached = true;
  const sync = () => {
    router.path = fromLocation();
  };
  try {
    window.addEventListener("popstate", sync);
    window.addEventListener("hashchange", sync);
  } catch {
  }
}
